"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
exports.__esModule = true;
exports.state = exports.dispatch = void 0;
var rxjs_1 = require("rxjs");
var operators_1 = require("rxjs/operators");
var constants_1 = require("../constants");
var utils_1 = require("../utils");
var constants_2 = require("./constants");
var _store = new rxjs_1.BehaviorSubject(constants_1.APP_INITIAL_STATE);
var _stateUpdates = new rxjs_1.Subject();
_stateUpdates.subscribe(_store);
function reducer(state, action) {
    var type = action.type, payload = action.payload;
    switch (type) {
        case constants_2.ADD_CHAINS:
            return __assign(__assign({}, state), { chains: __spreadArray(__spreadArray([], state.chains, true), payload, true) });
        case constants_2.ADD_WALLET: {
            var wallet_1 = payload;
            var existingWallet = state.wallets.find(function (_a) {
                var label = _a.label;
                return label === wallet_1.label;
            });
            return __assign(__assign({}, state), { wallets: __spreadArray([
                    // add to front of wallets as it is now the primary wallet
                    existingWallet || payload
                ], state.wallets.filter(function (_a) {
                    var label = _a.label;
                    return label !== wallet_1.label;
                }), true) });
        }
        case constants_2.UPDATE_WALLET: {
            var update = payload;
            var id_1 = update.id, walletUpdate_1 = __rest(update, ["id"]);
            var updatedWallets = state.wallets.map(function (wallet) {
                return wallet.label === id_1 ? __assign(__assign({}, wallet), walletUpdate_1) : wallet;
            });
            return __assign(__assign({}, state), { wallets: updatedWallets });
        }
        case constants_2.REMOVE_WALLET: {
            var update_1 = payload;
            return __assign(__assign({}, state), { wallets: state.wallets.filter(function (_a) {
                    var label = _a.label;
                    return label !== update_1.id;
                }) });
        }
        case constants_2.UPDATE_ACCOUNT: {
            var update = payload;
            var id_2 = update.id, address_1 = update.address, accountUpdate_1 = __rest(update, ["id", "address"]);
            var updatedWallets = state.wallets.map(function (wallet) {
                if (wallet.label === id_2) {
                    wallet.accounts = wallet.accounts.map(function (account) {
                        if (account.address === address_1) {
                            return __assign(__assign({}, account), accountUpdate_1);
                        }
                        return account;
                    });
                }
                return wallet;
            });
            return __assign(__assign({}, state), { wallets: updatedWallets });
        }
        case constants_2.SET_WALLET_MODULES: {
            return __assign(__assign({}, state), { walletModules: payload });
        }
        case constants_2.RESET_STORE:
            return constants_1.APP_INITIAL_STATE;
        default:
            throw new Error("Unknown type: ".concat(type, " in appStore reducer"));
    }
}
function dispatch(action) {
    var state = _store.getValue();
    _stateUpdates.next(reducer(state, action));
}
exports.dispatch = dispatch;
function select(stateKey) {
    if (!stateKey)
        return _stateUpdates.asObservable();
    var validStateKeys = Object.keys(_store.getValue());
    if (!validStateKeys.includes(String(stateKey))) {
        throw new Error("key: ".concat(stateKey, " does not exist on this store"));
    }
    return _stateUpdates.asObservable().pipe((0, operators_1.distinctUntilKeyChanged)(stateKey), (0, operators_1.map)(function (x) { return x === null || x === void 0 ? void 0 : x[stateKey]; }), (0, operators_1.filter)(utils_1.notNullish));
}
function get() {
    return _store.getValue();
}
exports.state = {
    select: select,
    get: get
};
